import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';

const format = (raw: string) => new AsYouType('US').input(raw);

const isDigit = (c: string | undefined) => !!c && c >= '0' && c <= '9';

// AsYouType picks the international shape (`+1 555 123 4567`) for E.164
// values, which strips the parentheses. For hydration from the BE we want
// the national shape (`(555) 123-4567`). Route E.164 inputs through
// parsePhoneNumber for that; partial / bare-digit inputs keep using
// AsYouType so progressive typing still works.
export const formatPhoneForDisplay = (raw: string): string => {
  if (!raw) return '';
  if (raw.startsWith('+')) {
    const parsed = parsePhoneNumberFromString(raw, 'US');
    if (parsed) return parsed.formatNational();
  }
  return format(raw);
};

// libphonenumber's AsYouType re-injects format chars ("(", ")", " ", "-")
// on every input pass. That means backspacing past a generated format
// char silently re-formats back to the same string, so the field gets
// stuck. When we detect that the only thing that changed is a trailing
// format char being dropped, we strip the preceding digit as well.
// Paste / replace / hydration paths skip this and just re-format.
export const formatPhoneOnChange = (prev: string, next: string): string => {
  const lastChar = prev[prev.length - 1];
  const removedSingleFormatChar =
    next.length === prev.length - 1 && next === prev.slice(0, -1) && !isDigit(lastChar);

  if (!removedSingleFormatChar) {
    return format(next);
  }

  let i = prev.length - 1;
  for (; i >= 0; i--) {
    if (isDigit(prev[i])) break;
  }

  return format(prev.substring(0, Math.max(0, i)));
};
